export default {
  'open-menu': 'Apri il menu',
  'close-menu': 'Chiudi',
  'editorial-staff': 'Redazione',
  about: 'Questi siamo noi',
  shopLink: 'Un mondo di possibilità',
}
